import { Injectable } from '@angular/core';
import { Router, CanActivate, NavigationEnd, Event } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class AuthGuard implements CanActivate {
    
    constructor(private router: Router, private http: HttpClient) {}

    canActivate() 
    {
        console.log("Currently login status : "+sessionStorage.getItem('isLoggedin'));
        if (sessionStorage.getItem('isLoggedin')) {

            this.router.events.subscribe((event: Event) => {
                /* Add Dynamic Inline Manual */
                if (event instanceof NavigationEnd ) {                
                  /* console.log("URL :::"+event.url);
                  if(event.url == '/dialer' || event.url == '/dialer/career')
                  {                                        
                    var element = document.getElementById("inlinetag");
                    while (element.firstChild) {
                        element.removeChild(element.firstChild);
                        }                                  
                  }
                  else
                  {          */      
                    var len = $('script').filter(function () {
                      return ($(this).attr('src') == '../../assets/inlinemanualjs.js');
                    }).length;
                    
                    //if there are no scripts that match, the load it
                    if (len == 0) {
                        console.log(len);                        
                        var fileref=document.createElement('script');
                        fileref.setAttribute("type","text/javascript");
                        fileref.setAttribute("src", "../../assets/inlinemanualjs.js");
                        document.getElementById("inlinetag").appendChild(fileref);
                    }                    

                 // }
                }
              });
            return true;
        }

        this.router.navigate(['/login']);
        return false;
    }
}
